// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/utils/safeReturnUrl.ts"
);
import.meta.hot.lastModified = "1768503564425.5122";
}
// REMIX HMR END

import { redirect } from '@remix-run/cloudflare'

export function safeRedirect(url: string, init?: number | ResponseInit) {
	if (
		// eslint-disable-next-line no-script-url
		['javascript:', 'data:', 'vbscript:'].some((str) =>
			decodeURI(url).trim().toLowerCase().startsWith(str)
		)
	) {
		url = '/'
	}
	return redirect(url, init)
}
